export default __webpack_public_path__ + "static/media/newLogoText.d229f9a5.png";